import { generateHeadersAuth, generateHeadersCfTns } from "../auth/authFunctions"
import { apiAriannaGW, apiAriannaTS } from "./api"


export const getProfiloAriannaApiTS = async () => {
    return await apiAriannaTS.get("/api/patient?withHistory=true", { headers: generateHeadersCfTns() })
}

export const getProfiloAriannaApiSPID = async () => {
    return await apiAriannaGW.get("/patient?withHistory=true")
}

export const patchProfiloAriannaApiTS = async (body) => {
    return await apiAriannaTS.patch("/api/patient", body, { headers: generateHeadersCfTns() })
}

export const patchProfiloAriannaApiSPID = async (body) => {
    return await apiAriannaGW.patch("/patient", body)
}

export const getScreeningResultApiTS = async (body) => {
    return await apiAriannaTS.get("/api/patient/screening-result", { params: { screeningTypeCode: body }, headers: generateHeadersCfTns() });
}

export const getScreeningResultApiSPID = async (body) => {
    return await apiAriannaGW.get('/patient/screening-result', { params: { screeningTypeCode: body } });
}

export const getAdhesionStatusApiTS = async () => {
    return await apiAriannaTS.get("/api/patient/adhesion-status", { headers: generateHeadersCfTns() });
}

export const getAdhesionStatusApiSPID = async () => {
    return await apiAriannaGW.get("/patient/adhesion-status");
}

export const getInviteReminderApiTS = async () => {
    return await apiAriannaTS.get("/api/patient/invite-reminder", { headers: generateHeadersCfTns() });
}

export const getInviteReminderApiSPID = async () => {
    return await apiAriannaGW.get('/patient/invite-reminder');
}

export const postAppointmentCancelApiTS = async (body) => {
    return await apiAriannaTS.post("/api/appointment/cancel", body, { headers: generateHeadersCfTns() });
}

export const postAppointmentCancelApiSPID = async (body) => {
    return await apiAriannaGW.post("/appointment/cancel", body);
}

export const postAppointmentConfirmApiTS = async (body) => {
    return await apiAriannaTS.post("/api/appointment/" + body.idAppointment,
        { "withdrawalMethod": body.withdrawalMethod },
        { headers: generateHeadersCfTns() });
}

export const postAppointmentConfirmApiSPID = async (body) => {
    return await apiAriannaGW.post("/appointment/" + body.idAppointment,
        { "withdrawalMethod": body.withdrawalMethod });
}

export const getCampagneAttiveScreeningApiTS = async (codiceAsl) => {
    const queryParams = codiceAsl ? "?codiceAsl=" + codiceAsl : ""
    return await apiAriannaTS.get("/api/screening" + queryParams, { headers: generateHeadersAuth() });
}

